import React, { useEffect, useState } from "react";
import heart from "../../Images/Vector (10).png";
import redHeart from "../../Images/red-heart.png";
import whatsapp from "../../Images/Group 534.png";
import arrow2 from "../../Images/Vector (11).png";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";
import noimage from "../../Images/common_Image.jpg";
import MediaSlider from "./MediaSlider";
import RemarksPopup from "./RemarksPopup";
import { useNavigate } from "react-router-dom";
import ReportPropertyPopUp from "./ReportPropertyPopUp";
import { GoDotFill } from "react-icons/go";

const PropertyCard = ({
  property,
  index,
  handleClick,
  showFav,
  activeData,
  advertisementShowingOrder,
  // visibility,
  // handleRemarksSubmit,
}) => {
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [isRemarksOpen, setIsRemarksOpen] = useState(false);
  const [showAds, setShowAds] = useState(false);
  const [advertisement, setAdvertisement] = useState([]);
  const [propertyObject, setPropertyObject] = useState({});
  const [isReportPropertyPopUpOpen, setIsReportPropertyPopUpOpen] =
    useState(false);
  const [propertyIdForReportProperty, setPropertyIdForReportProperty] =
    useState("");
  const [adShowingOrder, setAdShowingOrder] = useState(null);
  const [remarks, setRemarks] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    // Set advertisement showing order from props
    if (advertisementShowingOrder) {
      // Get the sequence number from the first order
      const sequenceNumber = advertisementShowingOrder;
      setAdShowingOrder(sequenceNumber);

      // Check if current index matches the advertisement showing order
      // Note: index is 0-based, so we use (index + 1) for 1-based counting
      if (sequenceNumber && (index + 1) % sequenceNumber === 0) {
        setShowAds(true);
        fetchRandomAd();
      } else {
        setShowAds(false);
      }
    }
  }, [index, advertisementShowingOrder]);

  useEffect(() => {
    setPropertyObject(property);
  }, [property]);

  const fetchRandomAd = async () => {
    try {
      const res = await HomeService.getAdvertisement();
      if (res?.data && res.data.length > 0) {
        const randomAd = res.data[Math.floor(Math.random() * res.data.length)];
        setAdvertisement(randomAd);
      } else {
        setShowAds(false);
      }
    } catch (error) {
      console.error("Error fetching advertisement:", error);
      setShowAds(false);
    }
  };

  const handleShareClick = (property) => {
    const subject = `${property.propertytype?.propertyType} in ${property.locality?.name}`;
    const body =
      `I am interested in the ${property.propertytype?.propertyType} at ${property.address}.` +
      `%0D%0AFound information from Winners`;

    const mailtoLink = `mailto:?subject=${encodeURIComponent(
      subject,
    )}&body=${body}`;

    const link = document.createElement("a");
    link.href = mailtoLink;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openWhatsAppLink = (e, phoneNumber, textMessage) => {
    e.preventDefault();
    const isMobile =
      /iPhone|Android|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    const encodedText = encodeURIComponent(textMessage);
    const link = isMobile
      ? `https://wa.me/${phoneNumber}?text=${encodedText}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedText}`;

    // Create an <a> element and simulate a click
    const a = document.createElement("a");
    a.href = link;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    a.click();
  };

  const handleRemarksSubmit = async (id) => {
    console.log("data", remarks);
    try {
      const res = await HomeService.addRemarks({
        propertyId: id,
        remarks,
      });
      if (res?.status) {
        toast.success(res.message);
      } else {
        toast.error(res.message || "Error while adding Remarks!");
      }
    } catch (error) {
      console.error("Error While adding Remarks!");
    }
    setRemarks("");
  };

  const onClose = () => {
    setIsOpenMedia(false);
  };

  const onCloseRemarks = () => {
    setIsRemarksOpen(false);
  };

  const firstImageUrl =
    property.images?.find((url) => url.match(/\.(jpg|jpeg|png|gif|webp)$/i)) ||
    noimage;

  const parts = [
    property?.aptName,
    property?.locality?.name,
    property?.city?.name,
    property?.address,
  ].filter(Boolean);
  const fullAddress = parts.join(", ");

  const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
    fullAddress,
  )}`;

  // Generic function to format date from ISO string to "14th August 2025" format
  const formatDate = (isoDateString) => {
    if (!isoDateString) return "";

    const date = new Date(isoDateString);

    // Check if date is valid
    if (isNaN(date.getTime())) return "";

    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "long" });
    const year = date.getFullYear();

    // Add ordinal suffix to day
    const getOrdinalSuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month} ${year}`;
  };
  const closeReportPropertyPopUp = () => {
    setIsReportPropertyPopUpOpen(false);
  };

  const handleViewProperty = async (id) => {
    try {
      const res = await HomeService.clickCountAndViewProperty({
        propertyId: id,
      });
      console.log("view count", res);
      if (res?.status && res?.data?.clickCount < 3) {
        setPropertyObject((prev) => ({
          ...prev,
          visibility: res?.data?.visibility,
        }));
      } else {
        toast.error(res?.message);
        navigate("/pricingplan");
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    }
  };

  const formatDateWithOrdinal = (isoDateString) => {
    const date = new Date(isoDateString);

    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    const month = date.toLocaleString("en-US", {
      month: "long",
      timeZone: "UTC",
    });

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  return (
    <>
      <div>
        {isOpenMedia && (
          <MediaSlider mediaArray={property?.images} onClose={onClose} />
        )}
        <div
          className="property_grid_one property_grid_new_class"
          key={property._id || index}
          // style={{ height: "18rem" }}
        >
          <div
            className="propety_grid_img property_grid_img_new"
            style={{ position: "relative" }}
          >
            <img
              onClick={() => {
                setIsOpenMedia(true);
              }}
              className="propety_grid_img_display propety_grid_img_display_new"
              src={firstImageUrl}
              alt="Property"
              style={{ cursor: "pointer" }}
            />
            {showFav && propertyObject?.visibility && (
              <div
                className="heart_div_2"
                style={{ cursor: "pointer" }}
                onClick={(e) => handleClick(e, property._id)}
              >
                <img
                  src={property?.isFavorite ? redHeart : heart}
                  alt="Favorite"
                />
              </div>
            )}
            {property?.images?.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  height: "20px",
                  borderRadius: "20px",
                  // backgroundColor: "white",
                  bottom: "5%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  left: "5%",
                  backgroundColor: "black",
                }}
              >
                {property?.images?.map((e, i) => {
                  return <GoDotFill style={{ color: "white" }} />;
                })}
              </div>
            )}
          </div>

          <div className="property_grid_data property_grid_data_new">
            <div className="profile_row_ps">
              {property?.name ? (
                <div className="profile_left_ps">
                  <div className="profile_avatar_ps">
                    {property?.name?.slice(0, 1)?.toUpperCase()}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span className="profile_name_ps">{property?.name} </span>
                    <div
                      // style={{
                      //   color: "#273c5c",
                      //   fontWeight: "600",
                      //   marginBottom: "3px",
                      //   fontSize: "12px",
                      // }}
                      className="ptan"
                    >
                      {property?.contactType
                        ? `(${property?.contactType})`
                        : ""}
                    </div>
                  </div>
                </div>
              ) : property?.contactType === "Owner" && property?.name === "" ? (
                <div className="profile_left_ps">
                  <div className="profile_avatar_ps">
                    {"Owner"?.slice(0, 1)?.toUpperCase()}
                  </div>
                  <span className="profile_name_ps">Owner</span>
                </div>
              ) : (
                <div className="profile_left_ps">
                  <div className="profile_avatar_ps">
                    {property?.name?.slice(0, 1)?.toUpperCase()}
                  </div>
                  <span className="profile_name_ps">Null</span>
                </div>
              )}

              <div className="profile_right_ps">
                <i className="fa-regular fa-calendar calendar_icon_ps"></i>
                <span className="profile_date_ps">
                  {formatDateWithOrdinal(property?.createdOn)}
                </span>
              </div>
            </div>
            <h5
              className="pro_name_ps"
              style={{
                filter: !propertyObject?.visibility ? "blur(4px)" : "",
              }}
            >
              {property?.bhk
                ? `${property?.bhk || ""} bhk ${
                    property?.propertytype?.propertyType || ""
                  } ${property?.propertyFor || ""} in ${
                    property?.locality?.name || ""
                  } ${property?.city?.name || ""}`
                : `${property?.propertytype?.propertyType || ""} ${
                    property?.propertyFor || ""
                  } in ${property?.locality?.name || ""} ${
                    property?.city?.name || ""
                  }`}
            </h5>
            <div className="property_grid_content">
              <div className="property_data">
                {/* {property?.locality?.name && (
                  <div className="property_para_div">
                    <p className="property_data_para">Locality:</p>
                    <p
                      className="property_data_para2"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {property.locality?.name || "N/A"}
                    </p>
                  </div>
                )} */}
                {/* {property.address && (
                  <div className="property_para_div">
                    <p className="property_data_para">Address:</p>
                    <p
                      className="property_data_para2"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {property.address || "N/A"}
                      {property?.newEntry || ""}
                    </p>
                  </div>
                )} */}

                <div className="property_para_div">
                  <p className="property_data_para">Area:</p>
                  <p
                    className="property_data_para2"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    {property?.area || "Null"}{" "}
                    {property?.area ? property?.unit || "" : ""}
                  </p>
                </div>

                <div className="property_para_div">
                  <p className="property_data_para">Age:</p>
                  <p
                    className="property_data_para2"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    {property.age || "Null"}
                  </p>
                </div>

                {/* <div className="property_para_div">
                  <p className="property_data_para">Contact Number:</p>
                  <p
                    className="property_data_para2"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    
                    {property?.phoneNo && !property?.price
                      ? "Call For Price"
                      : property?.phoneNo || ""}
                  </p>
                </div> */}
                <div className="property_para_div">
                  <p className="property_data_para">Contact Number:</p>
                  <p
                    className="property_data_para2"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    {/* {property?.phoneNo
                      ? property?.price
                        ? property.phoneNo
                        : "Call For Price"
                      : ""} */}
                    {property?.phoneNo || "Null"}
                  </p>
                </div>

                {/* {property?.bhk && (
                  <div className="property_para_div">
                    <p className="property_data_para">BHK:</p>
                    <p
                      className="property_data_para2"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {property?.bhk || ""}
                    </p>
                  </div>
                )} */}
                {/* {property?.facing?.facing && (
                  <div className="property_para_div">
                    <p className="property_data_para">Facing:</p>
                    <p
                      className="property_data_para2"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {property?.facing?.facing || "N/A"}
                    </p>
                  </div>
                )} */}
                {/* {property?.date && (
                  <div className="property_para_div">
                    <p className="property_data_para">Listed By:</p>
                    <p
                      className="property_data_para2"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {formatDate(property?.date) || "N/A"}
                    </p>
                  </div>
                )} */}
                {/* {property?.floor && (
                  <div className="property_para_div" style={{ width: "200%" }}>
                    <p
                      className="property_data_para"
                      style={{
                        marginBottom: "10px",
                      }}
                    >
                      Floor:
                    </p>
                    {property?.floor?.includes("+") ? (
                      <div
                        style={{
                          width: "100%",
                          height: "100px",
                          overflowY: "auto",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                          filter: !propertyObject?.visibility
                            ? "blur(4px)"
                            : "",
                        }}
                      >
                        {property?.floor?.split("+").map((e, i) => (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "7px",
                              width: "fit-content",
                            }}
                          >
                            <h6
                              style={{
                                fontWeight: "600",
                                fontSize: "13px",
                              }}
                            >
                              {e}
                            </h6>
                            <h3
                              style={{
                                fontWeight: "600",
                                fontSize: "15px",
                              }}
                            >
                              {property?.price?.toString()?.includes("+") &&
                                property?.price?.split("+")[i]}
                              {property?.priceUnit === "LKH"
                                ? "Lakh"
                                : property?.priceUnit === "TH"
                                ? "Thousand"
                                : property?.priceUnit === "CR"
                                ? "Crore"
                                : ""}
                            </h3>
                            <button
                              style={{
                                padding: "5px 10px",
                                border: "none",
                                background: "#85da4f",
                                fontWeight: "500",
                                fontSize: "12px",
                              }}
                            >
                              AVAILABLE
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: "100px",
                          overflowY: "auto",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                          filter: !propertyObject?.visibility
                            ? "blur(4px)"
                            : "",
                        }}
                      >
                        {property?.floor?.split("+").map((e, i) => (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: "7px",
                              width: "fit-content",
                            }}
                          >
                            <h6
                              style={{
                                fontWeight: "600",
                                fontSize: "13px",
                              }}
                            >
                              {e}
                            </h6>
                            <h3
                              style={{
                                fontWeight: "600",
                                fontSize: "15px",
                              }}
                            >
                              {property?.price?.toString()?.split("+")[i]}
                              {property?.priceUnit === "LKH"
                                ? "Lakh"
                                : property?.priceUnit === "TH"
                                ? "Thousand"
                                : property?.priceUnit === "CR"
                                ? "Crore"
                                : ""}
                            </h3>
                            <button
                              style={{
                                padding: "5px 10px",
                                border: "none",
                                background: "#85da4f",
                                fontWeight: "500",
                                fontSize: "12px",
                              }}
                            >
                              AVAILABLE
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )} */}

                {/* {!property?.floor && !property?.floor?.includes("+") && (
                  <div className="property_para_div">
                    <p className="property_data_para">Price:</p>
                    <p
                      className="property_data_para2"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {property?.price || "Call For Price"}
                      {property?.price && property?.priceUnit === "LKH"
                        ? "Lakh"
                        : property?.priceUnit === "TH"
                        ? "Thousand"
                        : property?.priceUnit === "CR"
                        ? "Crore"
                        : ""}
                    </p>
                  </div>
                )} */}

                {/* {property.name && (
                  <div className="property_para_div">
                    <p className="property_data_para">
                      {property?.contactType || ""} Name:
                    </p>
                    <p
                      className="property_data_para2"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {property.name || "N/A"}
                    </p>
                  </div>
                )} */}
              </div>
              <div className="property_data">
                {/* <div className="property_para_div">
                  <p className="property_data_para">
                    {property?.contactType || ""} Name:
                  </p>
                  <p
                    className="property_data_para2"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    {property?.name || "Null"}
                  </p>
                </div> */}
                <div className="property_para_div">
                  <p className="property_data_para">Type:</p>
                  <p
                    className="property_data_para2"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    {property?.propertytype?.propertyType || "Null"}
                  </p>
                </div>

                <div className="property_para_div">
                  <p className="property_data_para">BHK:</p>
                  <p
                    className="property_data_para2"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    {property?.bhk || "Null"}
                  </p>
                </div>
                <div className="property_para_div">
                  <p className="property_data_para">Price:</p>
                  <p
                    className="property_data_para2"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    {property?.price || "Call For Price"}{" "}
                    {property?.priceUnit === "LKH"
                      ? "Lakh"
                      : property?.priceUnit === "TH"
                        ? "Thousand"
                        : property?.priceUnit === "CR"
                          ? "Crore"
                          : ""}
                  </p>
                </div>
              </div>
              <div className="property_data">
                <div className="property_para_div"></div>

                {/* <div className="property_para_div">
                  <p className="property_data_para">Type:</p>
                  <p
                    className="property_data_para2"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    {property?.propertytype?.propertyType || "Null"}
                  </p>
                </div> */}

                <div className="property_para_div">
                  <p className="property_data_para"> For:</p>
                  <p
                    className="property_data_para2 text-capitalize"
                    style={{
                      filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    }}
                  >
                    {property.propertyFor || "Null"}
                  </p>
                </div>

                {/* {property?.phoneNo &&
                property?.phoneNo?.split(",").length > 1 ? (
                  property?.phoneNo?.split(",").map((e, i) => {
                    return (
                      <div className="property_para_div" key={i}>
                        <p className="property_data_para"> Contact{i + 1}:</p>
                        <p
                          className="property_data_para2 text-capitalize"
                          style={{
                            filter: !propertyObject?.visibility
                              ? "blur(4px)"
                              : "",
                          }}
                        >
                          {e || "N/A"}
                        </p>
                      </div>
                    );
                  })
                ) : (
                  <div className="property_para_div">
                    <p className="property_data_para"> Contact:</p>
                    <p
                      className="property_data_para2 text-capitalize"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {property.phoneNo || "N/A"}
                    </p>
                  </div>
                )} */}
                {/* {property?.bhk && (
                  <div className="property_para_div">
                    <p className="property_data_para">BHK:</p>
                    <p
                      className="property_data_para2"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {property?.bhk || ""}
                    </p>
                  </div>
                )} */}
                {/* {property.extra && (
                  <div className="property_para_div">
                    <p className="property_data_para">Extra:</p>
                    <p
                      className="property_data_para2"
                      style={{
                        filter: !propertyObject?.visibility ? "blur(4px)" : "",
                      }}
                    >
                      {property.extra || "N/A"}
                    </p>
                  </div>
                )} */}
              </div>
            </div>

            {/* <div className="property_para_div" style={{ marginTop: "15px" }}>
              <p className="property_data_para">Location:</p>
              <p
                className="property_data_para2"
                style={{
                  filter: !propertyObject?.visibility ? "blur(4px)" : "",
                }}
              >
                {property?.locationUrl ? (
                  <span style={{ marginLeft: "15px", cursor: "pointer" }}>
                    <a
                      href={property?.locationUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="fa-solid fa-location-dot"
                        style={{ fontSize: "20px" }}
                      ></i>
                    </a>
                  </span>
                ) : (
                  <span style={{ marginLeft: "15px", cursor: "pointer" }}>
                    <a href={mapUrl} target="_blank" rel="noopener noreferrer">
                      <i
                        className="fa-solid fa-location-dot"
                        style={{ fontSize: "20px" }}
                      ></i>
                    </a>
                  </span>
                )}
              </p>
            </div> */}

            {!propertyObject?.visibility && (
              <div>
                <button
                  style={{
                    marginLeft: "10px",
                    color: "white",
                    cursor: "pointer",
                    padding: "5px 10px",
                    backgroundColor: "black",
                    borderRadius: "5px",
                    border: "none",
                    marginTop: "15%",
                  }}
                  onClick={() => {
                    handleViewProperty(property?._id);
                  }}
                >
                  View Property
                </button>
              </div>
            )}

            {activeData && propertyObject?.visibility && (
              <>
                <div className="remark_button_wrapper_div">
                  <div
                    // style={{ display: "flex", justifyContent: "space-between" }}
                    className="rede"
                  >
                    <div>
                      {/* <p>
                        Remark
                        <span
                          onClick={() => {
                            setIsRemarksOpen(true);
                          }}
                          style={{
                            marginLeft: "10px",
                            color: "blue",
                            cursor: "pointer",
                          }}
                        >
                          (Show Remarks)
                        </span>{" "}
                      </p> */}
                    </div>
                    <div>
                      <span
                        style={{}}
                        onClick={() => {
                          localStorage.setItem("propertyId", property?._id);
                          window.open("/single-property", "_blank");
                        }}
                        className="yhss"
                      >
                        View Property Details
                      </span>
                    </div>
                  </div>
                  {/* <input
                    value={remarks}
                    onChange={(e) => {
                      setRemarks(e.target.value);
                    }}
                    type="text"
                    placeholder="Type something for your own use..."
                  /> */}
                  {/* <div className="submit_btn_icon_wrapper">
                    <button
                      onClick={() => {
                        handleRemarksSubmit(property._id);
                        setRemarks("");
                      }}
                    >
                      Submit
                    </button>
                    {isRemarksOpen && (
                      <RemarksPopup
                        remarksArray={property?.remarksArray}
                        onClose={onCloseRemarks}
                      />
                    )}
                    {activeData && (
                      <>
                        <div>
                          <span
                            style={{
                              color: "#ba1307",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setPropertyIdForReportProperty(property?._id);
                              setIsReportPropertyPopUpOpen(true);
                            }}
                          >
                            Report This Property
                          </span>
                        </div>
                        <div
                          className="d-flex"
                          style={{ columnGap: "12px", cursor: "pointer" }}
                        >
                          <div
                            className="icon_1_div"
                            onClick={() => handleClick(property._id)}
                          >
                            <img
                              src={property?.isFavorite ? redHeart : heart}
                              alt="Favorite"
                            />
                          </div>
                          <div
                            className="icon_1_div"
                            style={{ cursor: "pointer" }}
                            onClick={(e) =>
                              openWhatsAppLink(
                                e,
                                `91${property.phoneNo?.slice(0, 10)}`,
                                `Hi ${property.ownerName}, I am interested in your ${property.propertytype?.propertyType} at ${property.address}, ${property.locality?.name}`
                              )
                            }
                          >
                            <img src={whatsapp} alt="WhatsApp" />
                          </div>
                          <div
                            className="icon_1_div"
                            onClick={() => handleShareClick(property)}
                          >
                            <img src={arrow2} alt="Share" />
                          </div>
                        </div>
                      </>
                    )}
                  </div> */}
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Advertisement after every n-th property card based on advertisementShowingOrder */}
      {showAds && advertisement && adShowingOrder && (
        <div className="advertisement-card">
          <div className="ad-content">
            {advertisement.media && (
              <>
                {advertisement.media.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                  <img
                    style={{ width: "100%", height: "18rem" }}
                    src={advertisement.media}
                    alt="Advertisement"
                    className="ad-image"
                  />
                ) : (
                  <video
                    style={{ width: "100%", height: "40rem" }}
                    controls
                    className="ad-video"
                  >
                    <source src={advertisement.media} type="video/mp4" />
                  </video>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {/* Report Property PopUp */}
      {isReportPropertyPopUpOpen && (
        <ReportPropertyPopUp
          id={propertyIdForReportProperty}
          onClose={closeReportPropertyPopUp}
        />
      )}
    </>
  );
};

export default PropertyCard;
